import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { RouteComponentProps } from 'react-router';
import { OurRoute } from "./OurRoute";

export class RoutePortal extends OurRoute {

    namesMatch(currentHost, serverDataHost) {
        currentHost = currentHost.toLowerCase().replace("-east", "").replace("-north", "");
        serverDataHost = serverDataHost.toLowerCase().replace("-east", "").replace("-north", "");
        return currentHost === serverDataHost;
    }

    render() {
        //
        if (this.state.match) {
            //debugger;
            if (typeof window === 'undefined') {
                return super.render();
            }
            else {
                const serverData = window.serverData.data;  // we can assume the window object here because we won't 

                if (window.location.host.toLowerCase().indexOf("localhost") == -1  && !this.namesMatch(window.location.host, serverData.appDomain)) {
                    //debugger;
                    window.persistor.flush();
                    //window.setTimeout(() => {
                    //debugger;
                        window.location.host = serverData.appDomain;
                    //}, 100);
                    return "";
                }
                else {
                    return super.render();
                }
            }
        }
        else {
            return "";
        }
    }

}


export default RoutePortal;

